export default __webpack_public_path__ + "static/media/douroRiver-large.053728f8.jpg";